module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/eyecatch-calendar-c8c8c009aaf7e1501c570c3b29da4229.svg";